import { SagaIterator } from 'redux-saga';
import apiClient from '../common/apiClient';
import { DriverConfigType, DriverInfo } from 'src/features/profile/types';

export function fetchDriverInfoApi(): SagaIterator<DriverInfo> {
  return apiClient.get('/users/whoami', {});
}

export function fetchDriverConfigApi(driverId: number): SagaIterator<DriverConfigType> {
  return apiClient.get(`eld/drivers/${driverId}/config`, {});
}
